<agr-dialog
  [formGroup]="formGroup"
  (confirm)="save()"
  (cancel)="cancel()"
  [data]="data"
  class="slide-in"
>
  <div class="flex--column spacing--margin-top">
    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'barn' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="barn"
        data-test="vaccination-edit-item__barn"
      >
        <mat-option *ngFor="let barnMapping of data.barnMappings" [value]="barnMapping">
          {{ barnMapping.barnName }} - {{ barnMapping.animalGroupBarnId }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.date' | translate }}</mat-label>
      <input
        matInput
        formControlName="date"
        [matDatepicker]="vaccinationDatePicker"
        placeholder="{{ 'animal-group.date' | translate }}"
        data-test="vaccination-edit-item__date"
      />
      <mat-datepicker-toggle matIconSuffix [for]="vaccinationDatePicker"></mat-datepicker-toggle>
      <mat-datepicker touchUi #vaccinationDatePicker></mat-datepicker>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'product-overview.country' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="country"
        data-test="vaccination-edit-item__country"
        [(ngModel)]="selectedCountry"
        (ngModelChange)="countryChanged($event)"
      >
        <mat-option *ngFor="let country of data.countries" [value]="country">
          {{ country }}
        </mat-option>
      </mat-select>
    </mat-form-field>

    <mat-form-field class="flex__child--auto">
      <mat-label>{{ 'animal-group.vaccine' | translate }}</mat-label>
      <mat-select
        [hideSingleSelectionIndicator]="true"
        formControlName="vaccine"
        data-test="vaccination-edit-item__vaccine"
      >
        <mat-option *ngFor="let vaccine of codelistVaccinesByCountry" [value]="vaccine">
          {{ vaccine.name }}
        </mat-option>
      </mat-select>
    </mat-form-field>
  </div>
</agr-dialog>
